import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { GetCredentialEncryptionKeyRequest } from '~src/bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';

import { GetCredentialEncryptionKeyRequestAction, getCredentialEncryptionKeyRequestSucceeded } from '../actions/GetCredentialEncryptionKeyRequestAction';
import { IGetSiteEncryptionDataKeyResult } from '../models/CredentialEncryptionModels';
import { retrieveSiteEncryptionKey } from '../services/CredentialEncryptionKeyService';


export function* handleGetCredentialEncryptionKeyRequest(action: GetCredentialEncryptionKeyRequestAction) {
    try {
      const encryptionKey: IGetSiteEncryptionDataKeyResult =  yield call(retrieveSiteEncryptionKey);
      yield put(getCredentialEncryptionKeyRequestSucceeded(encryptionKey));
    } catch(e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }

export function* rootCredentialEncryptionSagas(): SagaIterator {
    yield takeLatest(GetCredentialEncryptionKeyRequest, handleGetCredentialEncryptionKeyRequest);
  }